export default "__VITE_ASSET__4325ea3f__"